var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FooterPart w-full h-48 flex justify-center items-center text-base mt-5 flex-col",staticStyle:{"background-color":"#fafafa"}},[_c('p',[_vm._v(" License: This website is website adapted from Nerfies and MathVista, licensed under a Creative Commons Attribution-ShareAlike 4.0 International License. ")]),_c('br')])
}]

export { render, staticRenderFns }